import { Button, Grid, Container, CircularProgress} from "@mui/material"
import { AddOrEditFormStyles } from "../../styles/AddOrEditFormStyles"
import { GeneralStyles } from "../../styles/GeneralStyles"
import Typography from '@mui/material/Typography';
import { useState } from "react"
import { deleteProductModelList, deleteProvinceModelList, deleteGenericModelList, deleteCotscoProdInventory, deleteGenericProdInventory } from "../../services/CatalogsService"
import { toast } from "react-toastify"
import { useLocation } from 'react-router-dom';

const DeleteForm = ({handleCloseModal, type, id, fetchData}) => {
    let token = localStorage.getItem("site");
    const [savingIsLoading, setSavingIsLoading] = useState(false)
    const location = useLocation();
    const { pathname } = location;

    const notifyInvalidEntity = (message) => toast.warn(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    })

    const notifyProductDelete = (message) => toast.success(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    })

    const deleteProduct = async ()=>{
        setSavingIsLoading(true)
        let response = null;
        try {
            switch (pathname) {
                case "/dashboard/products/CatGeneric":
                    response = await deleteGenericModelList(token, id)
                    break;
                case "/dashboard/products/CotscoProd":
                    response = await deleteCotscoProdInventory(token, id)
                    break;
                case "/dashboard/products/GenericProd":
                    response = await deleteGenericProdInventory(token, id)
                    break;
                default:
                    response = await deleteProductModelList(token, id)
            }		            
            if (response.status === 200) {
                notifyProductDelete(response.data.message)
                handleCloseModal()
                setSavingIsLoading(false)
                fetchData()                
            }
        } catch(err) {
            if (err.response.status === 400) {
                showDataEntityErrors(err.response.data.content)
            }
        } finally {
            setSavingIsLoading(false)
        }
    }

    const deleteProvince = async ()=>{
        setSavingIsLoading(true)
        try {
            const response = await deleteProvinceModelList(token, id)
            if (response.status === 200) {
                notifyProductDelete(response.data.message)
                handleCloseModal();
                setSavingIsLoading(false)  
                fetchData()                
            }
        } catch(err) {
            if (err.response.status === 400) {
                showDataEntityErrors(err.response.data.content)
            }
        } finally {
            setSavingIsLoading(false)
        }
    }

    const showDataEntityErrors = (errors) => {
        for (let i = 0; i < errors.length; i++) {
            notifyInvalidEntity(errors[i])        
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        switch(type) {
            case "PRODUCT":
                deleteProduct()
            break;
            case "PROVINCE":
                deleteProvince()
            break
            default: 
             break   

        }
    }


    return (
        <Container maxWidth="sm" sx={AddOrEditFormStyles.form}>
            <form className={AddOrEditFormStyles.form} onSubmit={(e) => handleSubmit(e)}>
                <Grid container>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                    Do you want delete?
                </Typography>
                </Grid>
                <Grid container sx={AddOrEditFormStyles.formActions} >
                    <Button onClick={handleCloseModal} variant="contained" sx={GeneralStyles.btnGrey}>Cancel</Button>
                    {<Button type="submit" variant="contained" color="error" style={{marginLeft: 10}}>{savingIsLoading ? <CircularProgress size={24} /> : "DELETE"}</Button>}
                </Grid>
            </form>
        </Container>
    )
}

export default DeleteForm